var map = {
	"./App": 54064,
	"./App.vue": 54064,
	"./assets/css/global.scss": 24968,
	"./assets/css/loading.scss": 37505,
	"./assets/css/reset.scss": 68726,
	"./assets/css/utils.scss": 51240,
	"./assets/css/viewCss/index.scss": 78426,
	"./assets/fonts/ARIALN.TTF": 51251,
	"./assets/fonts/ARIALNB.TTF": 16011,
	"./assets/fonts/ARIALNBI.TTF": 89324,
	"./assets/fonts/ARIALNI.TTF": 59188,
	"./assets/fonts/Arial-Black-Italic.ttf": 49366,
	"./assets/fonts/Inter-VariableFont_slnt,wght.ttf": 18120,
	"./assets/fonts/Poppins-Bold.ttf": 85717,
	"./assets/fonts/arial.ttf": 25615,
	"./assets/fonts/arialbd.ttf": 61033,
	"./assets/fonts/arialbi.ttf": 43672,
	"./assets/fonts/ariali.ttf": 14680,
	"./assets/fonts/ariblk.ttf": 54789,
	"./assets/fonts/font.css": 60912,
	"./assets/icons": 82890,
	"./assets/icons/": 82890,
	"./assets/icons/index": 82890,
	"./assets/icons/index.js": 82890,
	"./assets/icons/svg/icon-arrow.svg": 95361,
	"./assets/icons/svg/icon-arrow1.svg": 52594,
	"./assets/icons/svg/icon-arrow2.svg": 41281,
	"./assets/icons/svg/icon-close-invite.svg": 66416,
	"./assets/icons/svg/icon-close.svg": 15686,
	"./assets/icons/svg/icon-copy.svg": 38385,
	"./assets/icons/svg/icon-lfg.svg": 4015,
	"./assets/icons/svg/icon-refresh.svg": 30303,
	"./assets/icons/svg/icon-telegram.svg": 29611,
	"./assets/icons/svg/icon-twitter.svg": 74731,
	"./assets/icons/svg/icon-vector.svg": 89295,
	"./assets/icons/svg/icon-vector1.svg": 31340,
	"./assets/icons/svg/icon-vector2.svg": 10367,
	"./assets/images/Mask group.png": 84746,
	"./assets/images/avatar.png": 75536,
	"./assets/images/b.png": 1329,
	"./assets/images/b_bar.png": 25295,
	"./assets/images/bg-mini-game.png": 8429,
	"./assets/images/bg-ranking-ball.png": 75233,
	"./assets/images/bg.jpg": 45150,
	"./assets/images/center-box-image-1.png": 95682,
	"./assets/images/center-box-image-2.png": 43865,
	"./assets/images/center-box-image-3.png": 46960,
	"./assets/images/center-box-image-4.png": 89807,
	"./assets/images/enter-activity-100-zh-003.jpeg": 30959,
	"./assets/images/enter-activity-countdown-day2-kr.jpg": 624,
	"./assets/images/enter-activity-countdown-day2-zh.jpg": 13873,
	"./assets/images/enter-activity-notice1-kr.jpg": 51043,
	"./assets/images/enter-activity-notice1-zh.jpg": 93458,
	"./assets/images/enter-activity-notice2-kr.jpg": 8154,
	"./assets/images/enter-activity-notice2-zh.jpg": 28991,
	"./assets/images/enter-activity-notice3-kr.jpg": 42713,
	"./assets/images/enter-activity-notice3-zh.jpg": 92196,
	"./assets/images/footer-logo.png": 54716,
	"./assets/images/footer.png": 6730,
	"./assets/images/game-come-soon.png": 38102,
	"./assets/images/game-swiper1.png": 12515,
	"./assets/images/game-title-bg.png": 47782,
	"./assets/images/icon-add.svg": 86874,
	"./assets/images/icon-ranking-1.png": 60099,
	"./assets/images/icon-ranking-2.png": 6888,
	"./assets/images/icon-ranking-3.png": 17105,
	"./assets/images/icon-reward-1.png": 28968,
	"./assets/images/icon-reward-2.png": 82179,
	"./assets/images/icon-reward-3.png": 18074,
	"./assets/images/icon-sub.svg": 30413,
	"./assets/images/icon-vector.png": 86674,
	"./assets/images/icon-vector1.png": 529,
	"./assets/images/icon-vector2.png": 75866,
	"./assets/images/logo.png": 82806,
	"./assets/images/logo1.png": 22861,
	"./assets/images/logo3.png": 5823,
	"./assets/images/nav-item-bg.png": 36216,
	"./assets/images/nav-vector.png": 28622,
	"./assets/images/nft-mall-item-1.png": 29028,
	"./assets/images/nft-mall-item-2.png": 83679,
	"./assets/images/nft-mall-item-3.png": 87350,
	"./assets/images/node-bg.png": 98591,
	"./assets/images/p1-bg.png": 77436,
	"./assets/images/p1-img-1.png": 55870,
	"./assets/images/p1-img-bg.png": 31038,
	"./assets/images/p1-intro-bg.png": 68503,
	"./assets/images/p1-intro-bot-bg.png": 80667,
	"./assets/images/p1-intro-tit-bg.png": 74859,
	"./assets/images/p1-intro-tit-line.png": 30836,
	"./assets/images/p1-q1.png": 80523,
	"./assets/images/p1-q2.png": 15120,
	"./assets/images/p1-q3.png": 30873,
	"./assets/images/p2-bg.png": 4197,
	"./assets/images/p2-cv2-bg.png": 59493,
	"./assets/images/p2-cv2-icon-1.png": 29457,
	"./assets/images/p2-cv2-icon-2.png": 53210,
	"./assets/images/p2-cv2-icon-3.png": 43043,
	"./assets/images/p2-cv2-icon-4.png": 93644,
	"./assets/images/p2-cv2-icon-5.png": 5269,
	"./assets/images/p2-cv2-icon-6.png": 84894,
	"./assets/images/p2-img-1.png": 67965,
	"./assets/images/p2-img-2.png": 86758,
	"./assets/images/p2-img-3.png": 25775,
	"./assets/images/p2-img-4.png": 29904,
	"./assets/images/p2-img-bg.png": 18315,
	"./assets/images/p3-head-bg.png": 90061,
	"./assets/images/p3-img-3-ad.png": 14750,
	"./assets/images/p3-img-4-ad-11.png": 33688,
	"./assets/images/p3-img-4-ad.png": 18723,
	"./assets/images/p3-item-bg.png": 93268,
	"./assets/images/p5-bg.png": 40232,
	"./assets/images/profile-avatar.png": 98080,
	"./assets/images/ranking-bottom-bg.png": 49297,
	"./assets/images/roadmap-point.png": 62854,
	"./assets/images/s2-icon-1.png": 23938,
	"./assets/images/s2-icon-2.png": 37945,
	"./assets/images/s2-icon-3.png": 5840,
	"./assets/images/s2-icon-4.png": 18063,
	"./assets/images/swiper-1.jpg": 39285,
	"./assets/images/swiper-2.jpg": 13034,
	"./assets/images/swiper-3.jpg": 68871,
	"./assets/images/swiper-4.jpg": 62876,
	"./assets/images/swiper-5.jpg": 83929,
	"./assets/images/threeStar.png": 4859,
	"./assets/images/video.mp4": 18450,
	"./assets/images/wap/p1-intro-bot-bg.png": 48434,
	"./assets/images/wap/p2-bg.png": 74156,
	"./assets/images/wap/p2-img-3.png": 14364,
	"./assets/images/wap/p3-bg.png": 59947,
	"./assets/images/wap/p3-img-3-ad.png": 71919,
	"./assets/images/wap/p3-img-4-ad.png": 39906,
	"./assets/js/noZoom": 54199,
	"./assets/js/noZoom.js": 54199,
	"./assets/js/rem": 80491,
	"./assets/js/rem.js": 80491,
	"./assets/json/particlesP1": 95728,
	"./assets/json/particlesP1.json": 95728,
	"./assets/json/particlesP2": 51245,
	"./assets/json/particlesP2.json": 51245,
	"./assets/json/particlesP3": 54562,
	"./assets/json/particlesP3.json": 54562,
	"./components/AutoBursh": 14023,
	"./components/AutoBursh.vue": 14023,
	"./components/ButtonType1": 65234,
	"./components/ButtonType1.vue": 65234,
	"./components/CenterBoxConsignment": 79959,
	"./components/CenterBoxConsignment.vue": 79959,
	"./components/CenterBoxPurchase": 96821,
	"./components/CenterBoxPurchase.vue": 96821,
	"./components/CenterBoxStake": 72285,
	"./components/CenterBoxStake.vue": 72285,
	"./components/CenterBoxTransfer": 25158,
	"./components/CenterBoxTransfer.vue": 25158,
	"./components/CenterNftRecordDialog": 15672,
	"./components/CenterNftRecordDialog.vue": 15672,
	"./components/ChangeLanguageButton": 8476,
	"./components/ChangeLanguageButton.vue": 8476,
	"./components/CommonAnimButton": 37812,
	"./components/CommonAnimButton.vue": 37812,
	"./components/CommonDialog": 15765,
	"./components/CommonDialog.js": 15765,
	"./components/CommonTipsDialog": 30150,
	"./components/CommonTipsDialog.vue": 30150,
	"./components/ComputeView": 16180,
	"./components/ComputeView.vue": 16180,
	"./components/Demo-template": 9945,
	"./components/Demo-template.vue": 9945,
	"./components/EmptyLayout": 30091,
	"./components/EmptyLayout.vue": 30091,
	"./components/EnterAdDialog": 91935,
	"./components/EnterAdDialog.vue": 91935,
	"./components/EnterAdTipsDialog": 38588,
	"./components/EnterAdTipsDialog.vue": 38588,
	"./components/GameMiniRecord": 17877,
	"./components/GameMiniRecord.vue": 17877,
	"./components/InputNumCalView": 41974,
	"./components/InputNumCalView.vue": 41974,
	"./components/InputNumCalViewNftPurchase": 60244,
	"./components/InputNumCalViewNftPurchase.vue": 60244,
	"./components/InviteBindingDialog": 75804,
	"./components/InviteBindingDialog.vue": 75804,
	"./components/LayoutCenter": 78745,
	"./components/LayoutCenter.vue": 78745,
	"./components/LayoutCenterRewardRecord": 99612,
	"./components/LayoutCenterRewardRecord.vue": 99612,
	"./components/LayoutCenterRewards": 60748,
	"./components/LayoutCenterRewards.vue": 60748,
	"./components/LayoutRankingBottom": 89230,
	"./components/LayoutRankingBottom.vue": 89230,
	"./components/LayoutRankingDevote": 54411,
	"./components/LayoutRankingDevote.vue": 54411,
	"./components/LayoutRankingJianSheZhe": 64107,
	"./components/LayoutRankingJianSheZhe.vue": 64107,
	"./components/LevelContentItemView": 3775,
	"./components/LevelContentItemView.vue": 3775,
	"./components/Loading": 29341,
	"./components/Loading/": 29341,
	"./components/Loading/CommonLoading": 88015,
	"./components/Loading/CommonLoading.vue": 88015,
	"./components/Loading/index": 29341,
	"./components/Loading/index.js": 29341,
	"./components/NftItemPurchaseDialog": 67253,
	"./components/NftItemPurchaseDialog.vue": 67253,
	"./components/NftMallItem": 21068,
	"./components/NftMallItem.vue": 21068,
	"./components/NftMallSortFilter": 57291,
	"./components/NftMallSortFilter.vue": 57291,
	"./components/NodeRecord": 37383,
	"./components/NodeRecord.vue": 37383,
	"./components/PagerView": 56680,
	"./components/PagerView.vue": 56680,
	"./components/ProfileDialogRecharge": 42341,
	"./components/ProfileDialogRecharge.vue": 42341,
	"./components/ProfileDialogTransfer": 69435,
	"./components/ProfileDialogTransfer.vue": 69435,
	"./components/ProfileDialogWithdraw": 44842,
	"./components/ProfileDialogWithdraw.vue": 44842,
	"./components/ProfileRecordDialog": 38849,
	"./components/ProfileRecordDialog.vue": 38849,
	"./components/RectBalanceNotEnoughDialog": 28544,
	"./components/RectBalanceNotEnoughDialog.vue": 28544,
	"./components/ReferralDetailView": 95028,
	"./components/ReferralDetailView.vue": 95028,
	"./components/StakeRecord": 63158,
	"./components/StakeRecord.vue": 63158,
	"./components/StakeView": 36049,
	"./components/StakeView.vue": 36049,
	"./components/SwiperGameHeader": 91136,
	"./components/SwiperGameHeader.vue": 91136,
	"./components/SwiperHomeHeader": 86887,
	"./components/SwiperHomeHeader.vue": 86887,
	"./components/TotalOverview": 39609,
	"./components/TotalOverview.vue": 39609,
	"./components/layout": 21306,
	"./components/layout.vue": 21306,
	"./components/myPagination": 84651,
	"./components/myPagination.vue": 84651,
	"./components/mySwiper": 82874,
	"./components/mySwiper.vue": 82874,
	"./components/popClaimOrders": 19320,
	"./components/popClaimOrders.vue": 19320,
	"./components/popDialog": 41307,
	"./components/popDialog.vue": 41307,
	"./components/popPrompt": 75607,
	"./components/popPrompt.vue": 75607,
	"./components/popPromptCompute": 74528,
	"./components/popPromptCompute.vue": 74528,
	"./components/popPromptTwo": 84064,
	"./components/popPromptTwo.vue": 84064,
	"./components/subItem": 42087,
	"./components/subItem.vue": 42087,
	"./components/svgIcon": 42804,
	"./components/svgIcon.vue": 42804,
	"./config": 41332,
	"./config/": 41332,
	"./config/index": 41332,
	"./config/index.js": 41332,
	"./directive": 16739,
	"./directive/": 16739,
	"./directive/direct/v-anchor": 44381,
	"./directive/direct/v-anchor.js": 44381,
	"./directive/direct/v-copy": 89221,
	"./directive/direct/v-copy.js": 89221,
	"./directive/direct/v-debounce": 79063,
	"./directive/direct/v-debounce.js": 79063,
	"./directive/direct/v-draggable": 85025,
	"./directive/direct/v-draggable.js": 85025,
	"./directive/direct/v-scroll": 62229,
	"./directive/direct/v-scroll.js": 62229,
	"./directive/direct/v-shuibowen": 43510,
	"./directive/direct/v-shuibowen.js": 43510,
	"./directive/index": 16739,
	"./directive/index.js": 16739,
	"./http": 57086,
	"./http/": 57086,
	"./http/index": 57086,
	"./http/index.js": 57086,
	"./i18n": 1118,
	"./i18n/": 1118,
	"./i18n/i18nOption": 90923,
	"./i18n/i18nOption.json": 90923,
	"./i18n/index": 1118,
	"./i18n/index.js": 1118,
	"./i18n/json/Chs": 77727,
	"./i18n/json/Chs.json": 77727,
	"./i18n/json/En": 31462,
	"./i18n/json/En.json": 31462,
	"./i18n/json/Jp": 82759,
	"./i18n/json/Jp.json": 82759,
	"./i18n/json/Kr": 99408,
	"./i18n/json/Kr.json": 99408,
	"./i18n/json/Vnm": 20656,
	"./i18n/json/Vnm.json": 20656,
	"./main": 3912,
	"./main.js": 3912,
	"./mixins": 76272,
	"./mixins/": 76272,
	"./mixins/index": 76272,
	"./mixins/index.js": 76272,
	"./router": 72679,
	"./router/": 72679,
	"./router/index": 72679,
	"./router/index.js": 72679,
	"./store": 167,
	"./store/": 167,
	"./store/index": 167,
	"./store/index.js": 167,
	"./store/modules/claim": 5029,
	"./store/modules/claim.js": 5029,
	"./store/modules/node": 20405,
	"./store/modules/node.js": 20405,
	"./store/modules/private": 84422,
	"./store/modules/private.js": 84422,
	"./store/modules/purchase": 33582,
	"./store/modules/purchase.js": 33582,
	"./store/modules/server": 57762,
	"./store/modules/server.js": 57762,
	"./store/modules/stake": 75659,
	"./store/modules/stake.js": 75659,
	"./store/modules/stakeRecord": 92322,
	"./store/modules/stakeRecord.js": 92322,
	"./store/modules/wallet": 68828,
	"./store/modules/wallet.js": 68828,
	"./utils": 859,
	"./utils/": 859,
	"./utils/errcode": 35961,
	"./utils/errcode.js": 35961,
	"./utils/formatter": 81697,
	"./utils/formatter.js": 81697,
	"./utils/index": 859,
	"./utils/index.js": 859,
	"./view": 91400,
	"./view/": 91400,
	"./view/center": 21003,
	"./view/center.vue": 21003,
	"./view/game": 87835,
	"./view/game.vue": 87835,
	"./view/index": 91400,
	"./view/index.1": 85444,
	"./view/index.1.vue": 85444,
	"./view/index.vue": 91400,
	"./view/manage": 36218,
	"./view/manage.vue": 36218,
	"./view/nft": 18018,
	"./view/nft.vue": 18018,
	"./view/pri.1": 97223,
	"./view/pri.1.vue": 97223,
	"./view/profile": 1894,
	"./view/profile.vue": 1894,
	"./view/ranking": 85634,
	"./view/ranking.vue": 85634,
	"./web3Wallet": 50271,
	"./web3Wallet/": 50271,
	"./web3Wallet/config/config": 2561,
	"./web3Wallet/config/config.json": 2561,
	"./web3Wallet/config_for_test/config": 97590,
	"./web3Wallet/config_for_test/config.json": 97590,
	"./web3Wallet/contracts/coinStake": 57637,
	"./web3Wallet/contracts/coinStake.json": 57637,
	"./web3Wallet/contracts/mint": 88520,
	"./web3Wallet/contracts/mint.json": 88520,
	"./web3Wallet/contracts/nft": 90360,
	"./web3Wallet/contracts/nft.json": 90360,
	"./web3Wallet/contracts/privateMint": 79371,
	"./web3Wallet/contracts/privateMint.json": 79371,
	"./web3Wallet/contracts/rechargeAndWithdrawContract": 63922,
	"./web3Wallet/contracts/rechargeAndWithdrawContract.json": 63922,
	"./web3Wallet/contracts/stakeClaim": 20090,
	"./web3Wallet/contracts/stakeClaim.json": 20090,
	"./web3Wallet/contracts/token": 95713,
	"./web3Wallet/contracts/token.json": 95713,
	"./web3Wallet/contracts_for_test/buyNft": 98261,
	"./web3Wallet/contracts_for_test/buyNft.json": 98261,
	"./web3Wallet/contracts_for_test/coinStake": 47766,
	"./web3Wallet/contracts_for_test/coinStake.json": 47766,
	"./web3Wallet/contracts_for_test/mint": 12713,
	"./web3Wallet/contracts_for_test/mint.json": 12713,
	"./web3Wallet/contracts_for_test/nft": 54255,
	"./web3Wallet/contracts_for_test/nft.json": 54255,
	"./web3Wallet/contracts_for_test/privateMint": 8560,
	"./web3Wallet/contracts_for_test/privateMint.json": 8560,
	"./web3Wallet/contracts_for_test/rechargeAndWithdrawContract": 90073,
	"./web3Wallet/contracts_for_test/rechargeAndWithdrawContract.json": 90073,
	"./web3Wallet/contracts_for_test/stakeClaim": 45335,
	"./web3Wallet/contracts_for_test/stakeClaim.json": 45335,
	"./web3Wallet/contracts_for_test/token": 10930,
	"./web3Wallet/contracts_for_test/token.json": 10930,
	"./web3Wallet/index": 50271,
	"./web3Wallet/index.js": 50271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;